<template>
    <div>
        <div :class="['grid-x', 'grid-padding-x', 'page-header-container', 'hide-for-large', {'minified' : minified}]" ref="page-header-container">
            <transition name="page-header-fade">
                <div class="cell page-title-container">
                    <h1 class="display-3 semi-bold margin-0">{{ title }}</h1>
                </div>
            </transition>
        </div>
        <div class="grid-x grid-padding-x align-center page-title-container show-for-large">
            <div class="cell">
                <h1>{{ title }}</h1>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import PickupTimeModal from '@/components/front/time-scheduler/PickupTimeModal.vue';
import { Icon } from '@/front/icons';
import Settings, { SettingNamespace } from '@/utils/settings';
import { registerScrollCallback, removeScrollCallback } from '@/utils/scroll-event-manager';


@Component({
    components: { PickupTimeModal }
})
export default class PageHeader extends Vue
{
    @Prop(String) readonly title!: string;

    storeLogo: string = "";
    minified: boolean = false;
    prevScrollTop: number = 0;

    async created() {
        const settings = await Settings.getInstance();
        this.storeLogo = settings.get(SettingNamespace.GENERAL, 'store_logo')?.value;
    }

    mounted() {
        registerScrollCallback('page-header', this.onScroll);
    }

    onScroll(pageContentContainer: HTMLElement) {
        const pageHeaderContainer = <HTMLElement>this.$refs['page-header-container'];
        if (pageContentContainer.scrollTop > this.prevScrollTop && pageContentContainer.scrollTop > 20) {
            pageHeaderContainer.style.top = "-130px"; // disappear
        }
        if (pageContentContainer.scrollTop <= this.prevScrollTop) { // minified
            this.minified = true;
            pageHeaderContainer.style.top = "0px";
        }
        if (pageContentContainer.scrollTop <= 20) { // normal
            if (this.minified) this.minified = false;
            pageHeaderContainer.style.top = "0px";
        }
        this.prevScrollTop = pageContentContainer.scrollTop;
    }

    get Icon() {
        return Icon;
    }

    destroyed() {
        removeScrollCallback('page-header');
    }
}

</script>
<style lang="scss" scoped>
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.page-header-container {
    @include breakpoint(medium down) {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        padding: 15px 5px 25px;
        background: var(--page-header-bg);
        z-index: 11;
        transition: top .5s, padding .3s;

        &.minified {
            box-shadow: var(--page-header-shadow);
            padding-bottom: 10px;
            padding-top: 10px;
        }
    }
}

.page-title-container {
    @include breakpoint(medium down) {
        color: var(--page-header-mobile-color);
        padding-top: 15px;
    }

    @include breakpoint(large up) {
        color: var(--page-header-color);
        padding-bottom: 30px;
    }
}

.page-header-fade-enter-active {
  transition: opacity .5s;
}
.page-header-fade-leave-active {
  transition: opacity 0s;
}
.page-header-fade-enter, .page-header-fade-leave-to {
  opacity: 0;
}
</style>

